import { ExclusivePromoterProposalApi } from '@/api/exclusive-promoter-proposal.api';
import { LoadingService } from '@/services/loading.service';
import { NotificationService } from '@/services/notification.service';
import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';

type DataType = {
  proposalId: string;
}

@Component({
  selector: 'app-dialog-export-file',
  templateUrl: './dialog-export-file.component.html',
  styleUrls: ['./dialog-export-file.component.scss'],
})
export class DialogExportFileComponent {

  exportTypeFile: string = 'Excel';
  optionsFile: string[] = ['Excel', 'PDF Resumo', 'PDF Completo'];
  selectedOption: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogExportFileComponent>,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private router: Router,
    private exclusivePromoterProposalApi: ExclusivePromoterProposalApi,
  ) {

  }

  onRightButton() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  exportTypeSend(exportType: string) {
    if (exportType === 'Excel') {
      this.downloadAndSaveExcelFile('proposal.xlsx');
    }
    if (exportType === 'PDF Resumo') {
      this.downloadAndSaveFile('proposal-resume.pdf');
    }
    if (exportType === 'PDF Completo') {
      this.downloadAndSaveFileCompleted('proposal-completed.pdf');
    }
  }

  async downloadAndSaveExcelFile(fileName: string): Promise<void> {
    this.loadingService.show();
    try {
      const response = await this.exclusivePromoterProposalApi.exportFileExcel(this.data.proposalId);
      const blob = new Blob([response], { type: 'application/xlsx' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      this.notificationService.showSuccessMessage('Arquivo baixado com sucesso');
      this.loadingService.hide();
    } catch (error) {
      this.loadingService.hide();
      this.notificationService.showErrorMessages(['Erro ao baixar arquivo']);
    }
  }

  async downloadAndSaveFile(fileName: string): Promise<void> {
    this.loadingService.show();
    try {
      const response = await this.exclusivePromoterProposalApi.exportFilePdfResume(this.data.proposalId);
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      this.notificationService.showSuccessMessage('Arquivo baixado com sucesso');
      this.loadingService.hide();
    } catch (error) {
      this.loadingService.hide();
      this.notificationService.showErrorMessages(['Erro ao baixar arquivo']);
    }
  }

  async downloadAndSaveFileCompleted(fileName: string): Promise<void> {
    this.loadingService.show();
    try {
      const response = await this.exclusivePromoterProposalApi.exportFilePdfCompleted(this.data.proposalId);
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      this.notificationService.showSuccessMessage('Arquivo baixado com sucesso');
      this.loadingService.hide();
    } catch (error) {
      this.loadingService.hide();
      this.notificationService.showErrorMessages(['Erro ao baixar arquivo']);
    }
  }

  keypressDate(event: KeyboardEvent) {
    event.preventDefault();
    return;
  }
}
